import {setInitialLabware} from '../../actions/availableLabwareStateAction';
import {SignalREvent} from '../../../constants/dataEnum';

export const subscribeEvent = (hubObject) => (dispatch) => {
  // get connection url config (hubHost)

  hubObject.invoke(SignalREvent.GET_LABWARE_DEFINITIONS).then((response) => {
    console.info('event received:', SignalREvent.GET_LABWARE_DEFINITIONS);
    console.log(SignalREvent.GET_LABWARE_DEFINITIONS, response);
    dispatch(setInitialLabware(response));
  });
};

export default subscribeEvent;
